import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';

type questionnaireCode = 'BAS' | 'MED' | 'RES' | 'FIN';

interface Questionnaire {
  code: questionnaireCode;
  value: string;
  type: string;
}

interface UserContextProps {
  userData: any;
  setUserData: React.Dispatch<React.SetStateAction<any>>;
  getDynamicQuestionnaire: (code: questionnaireCode) => Questionnaire | undefined
}

const UserContext = createContext<UserContextProps | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [userData, setUserData] = useState<any>(() => {
    const storedData = sessionStorage.getItem('userData');
    return storedData ? JSON.parse(storedData) : {};
  });
  

  const getDynamicQuestionnaire = (code: questionnaireCode) => {
    return userData.questionnaire?.find((quest: Questionnaire) => quest.code === code);
  }

  const contextValue = useMemo(
    () => ({ userData, setUserData, getDynamicQuestionnaire }),
    [userData, setUserData, getDynamicQuestionnaire]
  );

  useEffect(() => {
    sessionStorage.setItem('userData', JSON.stringify(userData));
  }, [userData]);

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export function useUserSession() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserSession deve ser usado dentro de um UserProvider.');
  }
  return context;
}
